var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiStFree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C26.2092 12 28 13.79 28 16H30V13C30 13 30 12 31 12C32 12 32 13 32 13V16C32 16 32 18 30 18H28V22H30C32 22 32 24 32 24V27C32 27 32 28 31 28C30 28 30 27 30 27V24H28C28 26.21 26.2092 28 24 28H8C5.7908 28 4 26.21 4 24H2V27C2 27 2 28 1 28C0 28 0 27 0 27V24C0 24 0 22 2 22H4V18H2C0 18 0 16 0 16V13C0 13 0 12 1 12C2 12 2 13 2 13V16H4C4 13.79 5.7908 12 8 12H24ZM8 18V24H10V22H12V24H14V16H10L8 18ZM18 18H20V22H18V24H24V22H22V18H24V16H18V18ZM12 20H10V18H12V20ZM27 2C28 2 28 3 28 3V10H4V3C4 3 4 2 5 2C6 2 6 3 6 3V6H26V3C26 3 26 2 27 2Z",
    fill: "#34AC74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStFree);
export default __webpack_public_path__ + "static/media/ai_st_free.f9f1477f78b2bac953471168fe86a42a.svg";
export { ForwardRef as ReactComponent };